/**
 * Texture registry. Per-organ texture files live alongside this index so
 * multiple agents can add organ art in parallel without colliding.
 *
 * To add a new organ:
 *   1. Create `./{organ}.ts` exporting `register{Organ}Textures(scene, has)`.
 *   2. Import + call it below.
 *
 * Re-generating is harmless — `has` guards each texture key.
 */

import Phaser from 'phaser';
import { registerCoreTextures } from './core';
import { registerBrainTextures } from './brain';
import { registerStomachTextures } from './stomach';
import { registerIntestinesTextures } from './intestines';
import { registerLungsTextures } from './lungs';
import { registerDiaphragmTextures } from './diaphragm';
import { registerHeartTextures } from './heart';
import { registerToiletTextures } from './toilet';

export function generateAllTextures(scene: Phaser.Scene): void {
  const has = (k: string) => scene.textures.exists(k);
  registerCoreTextures(scene, has);
  registerBrainTextures(scene, has);
  registerStomachTextures(scene, has);
  registerIntestinesTextures(scene, has);
  registerLungsTextures(scene, has);
  registerDiaphragmTextures(scene, has);
  registerHeartTextures(scene, has);
  registerToiletTextures(scene, has);
}
